// Destinations

// Destinations parsing

// eslint-disable-next-line arrow-body-style
const setCountryDestinations = tabOffers => {
	return tabOffers.reduce((result, offer) => {
		const {
			Destination: { Name, CountryName },
		} = offer;
		const item = { label: Name, value: Name, countryName: CountryName };

		const singleCountry = result.find(entry => entry.title === CountryName);

		if (singleCountry) {
			// Check if the item with the same Name already exists
			if (!singleCountry.items.some(x => x.value === item.value)) {
				singleCountry.items.push(item);
				singleCountry.items.sort((a, b) => a.label.localeCompare(b.label));
			}
		} else {
			result.push({ title: CountryName, items: [item] });
		}
		return result;
	}, []);
};

// Default select / unselect
const handleDestinationSelections = (
	item,
	destinationSelections,
	transformedCountryDestinations
) => {
	let newSelectedItems = [...destinationSelections];
	if (destinationSelections.some(si => si.value === (item.title || item.value))) {
		newSelectedItems = destinationSelections.filter(x => x.value !== (item.title || item.value));
	} else {
		newSelectedItems.push(item);
	}
	const citiesInCountry = transformedCountryDestinations.find(
		x => x.title === (item.countryName || item.title)
	)?.items;

	// Selected City
	if (item.countryName) {
		const selectedCitiesInCountry = newSelectedItems.filter(x => x.countryName === item.countryName)
			.length;

		if (citiesInCountry?.length === selectedCitiesInCountry) {
			// Make sure country is selected as well
			newSelectedItems.push({
				label: item.countryName,
				title: item.countryName,
				value: item.countryName,
			});
		} else {
			// Make sure country is deselected
			newSelectedItems = newSelectedItems.filter(x => x.title !== item.countryName);
		}
	} else if (item.title) {
		// Deselect Country (deselect all city)
		if (!newSelectedItems.some(c => c.value === item.title)) {
			newSelectedItems = newSelectedItems.filter(i => i.countryName !== item.title);
		} else {
			// Select Country (select all city)
			// Remove all cities first before re-adding them instead of trying to get the diff and add
			newSelectedItems = newSelectedItems.filter(i => i.countryName !== item.title);
			newSelectedItems.push(...citiesInCountry);
		}
	}

	return newSelectedItems;
};

const setDestinationSelectionsInputLabel = (destinationSelections, label, selectedLabel) => {
	if (destinationSelections.length === 0) {
		return label;
	}

	if (destinationSelections.length === 1) {
		return destinationSelections[0]?.label;
	}

	const selectedCountryList = destinationSelections.filter(x => x.title);
	const selectedItemsWithoutCountry = destinationSelections.filter(x => !x.title);
	const countryWithoutDestinationsList = selectedCountryList.filter(
		country => !selectedItemsWithoutCountry.some(item => item.countryName === country.title)
	);

	return `${
		countryWithoutDestinationsList.length + destinationSelections.filter(x => !x.title).length
	} ${selectedLabel}`;
};

// Price range
const handlePriceRangeChange = (val1, val2, min, max, submittedPriceValue) => {
	if (
		(val2 === max && val1 === min) ||
		(val1 === submittedPriceValue && val2 === submittedPriceValue)
	) {
		return null;
	}
	return [val1, val2];
};

// Star ratings

// eslint-disable-next-line consistent-return
const setStarRatings = (offerType, tabOffers) => {
	if (offerType === "packages") {
		const starRatingsForOffer = [
			...new Set(tabOffers.map(offer => Math.floor(offer.AccommodationInfo.StarRating))),
		].sort((a, b) => b - a);

		return starRatingsForOffer?.map(rating => ({
			id: rating.toString(),
			label: rating === 5 ? rating.toString() : `${rating.toString()} & up`,
			value: rating,
		}));
	}
};

// Sorting items

const setSortingItems = (offerType, sortingItemLabels) => {
	if (offerType === "packages") {
		return [
			{
				label: sortingItemLabels.recommended,
				value: "recommended",
				id: "recommended",
			},
			{
				label: sortingItemLabels.priceLowToHigh,
				value: "priceLowToHigh",
				id: "priceLowToHigh",
			},
			{
				label: sortingItemLabels.priceHighToLow,
				value: "priceHighToLow",
				id: "priceHighToLow",
			},
			{
				label: sortingItemLabels.starRatingLowToHigh,
				value: "starRatingLowToHigh",
				id: "starRatingLowToHigh",
			},
			{
				label: sortingItemLabels.starRatingHighToLow,
				value: "starRatingHighToLow",
				id: "starRatingHighToLow",
			},
			{
				label: sortingItemLabels.hotelAz,
				value: "hotelAz",
				id: "hotelAz",
			},
			{
				label: sortingItemLabels.hotelZa,
				value: "hotelZa",
				id: "hotelZa",
			},
			{
				label: sortingItemLabels.departureEarliest,
				value: "departureEarliest",
				id: "departureEarliest",
			},
		];
	}

	return [
		{
			label: sortingItemLabels.priceLowToHigh,
			value: "priceLowToHigh",
			id: "priceLowToHigh",
		},
		{
			label: sortingItemLabels.priceHighToLow,
			value: "priceHighToLow",
			id: "priceHighToLow",
		},
		{
			label: sortingItemLabels.departureEarliest,
			value: "departureEarliest",
			id: "departureEarliest",
		},
	];
};

//  Filtering functions called on submit
const filterByDestination = (offers, dest) => {
	if (!dest || dest.length === 0) {
		return offers;
	}

	return offers.filter(({ Destination: { Name } }) => dest.some(({ label }) => Name === label));
};

const filterByPrice = (offers, price) => {
	if (!price || price <= 0) {
		return offers;
	}

	return offers.filter(({ Price }) => Price >= price[0] && Price <= price[1]);
};

const filterByStarRating = (offers, rating) => {
	if (!rating || rating.length === 0) {
		return offers;
	}

	return offers.filter(
		({ AccommodationInfo: { StarRating } }) => Math.floor(StarRating) >= rating.value
	);
};

const getRecommended = lang => {
	if (lang === "fr-CA") {
		return "Coups de cœur Sunwing";
	}
	return "Sunwing Favourites";
};

const sortOffers = (offers, option, locale) => {
	switch (option) {
		case "priceLowToHigh":
			return offers.sort((a, b) => a.Price - b.Price);
		case "priceHighToLow":
			return offers.sort((a, b) => b.Price - a.Price);
		case "starRatingLowToHigh":
			return offers.sort((a, b) => a.AccommodationInfo.StarRating - b.AccommodationInfo.StarRating);
		case "starRatingHighToLow":
			return offers.sort((a, b) => b.AccommodationInfo.StarRating - a.AccommodationInfo.StarRating);
		case "hotelAz":
			return offers.sort((a, b) =>
				a.AccommodationInfo.AccommodationName.localeCompare(b.AccommodationInfo.AccommodationName)
			);
		case "hotelZa":
			return offers.sort((a, b) =>
				b.AccommodationInfo.AccommodationName.localeCompare(a.AccommodationInfo.AccommodationName)
			);
		case "departureEarliest":
			return offers.sort((a, b) => new Date(a.DepartureDate) - new Date(b.DepartureDate));
		case "recommended":
		default: {
			const recommendedOffers = offers.filter(offer =>
				offer.Collection?.some(
					collection =>
						collection.collectionName?.NameOfTheConceptOrCollection === getRecommended(locale)
				)
			);
			const otherOffers = offers.filter(
				offer =>
					!offer.Collection?.some(
						collection =>
							collection.collectionName?.NameOfTheConceptOrCollection === getRecommended(locale)
					)
			);
			return [...recommendedOffers, ...otherOffers];
		}
	}
};

// Handle tabs
// eslint-disable-next-line consistent-return
const defaultOrderingTabData = (tabOffers, locale) => {
	if (tabOffers) {
		const recommendedOffers = tabOffers?.filter(offer =>
			offer.Collection?.some(
				collection =>
					collection.collectionName?.NameOfTheConceptOrCollection === getRecommended(locale)
			)
		);
		const otherOffers = tabOffers?.filter(
			offer =>
				!offer.Collection?.some(
					collection =>
						collection.collectionName?.NameOfTheConceptOrCollection === getRecommended(locale)
				)
		);

		const offers = [...recommendedOffers, ...otherOffers];

		return offers;
	}
};

const handleStarRatingSelection = (value, starRatings) => {
	const selectedOption = starRatings.find(x => x.value === Number(value));
	return selectedOption;
};

const handleSortingOptionSelection = (value, sortingItems) => {
	const selectedOption = sortingItems.find(x => x.value === value);
	return selectedOption;
};

export default setCountryDestinations;
export {
	setCountryDestinations,
	handleDestinationSelections,
	setDestinationSelectionsInputLabel,
	handlePriceRangeChange,
	setStarRatings,
	setSortingItems,
	filterByDestination,
	filterByPrice,
	filterByStarRating,
	sortOffers,
	defaultOrderingTabData,
	handleStarRatingSelection,
	handleSortingOptionSelection,
};
